import {
  Home,
  Settings,
  Users,
  Activity,
  Bell,
  UserCircle,
  Share2,
  Ticket,
  Building2,
  History,
} from "lucide-react";

export const ManiSliderLinks = () => {
  return [
    {
      icon: <Settings className="h-4 w-4" />,
      title: "dashbord.settings",
      hasSubmenu: true,
      submenu: [
        {
          icon: <Settings className="h-4 w-4" />,
          title: "dashbord.settings",
          link: "/settings",
          admin: true,
        },
        {
          icon: <Bell className="h-4 w-4" />,
          title: "dashbord.notifications",
          link: "/notifications",
          admin: true,
        },
        {
          icon: <UserCircle className="h-4 w-4" />,
          title: "dashbord.customers",
          link: "/customers",
        },
        {
          icon: <Share2 className="h-4 w-4" />,
          title: "gloabl.socialMedia",
          link: "/social-media",
        },
        {
          icon: <Ticket className="h-4 w-4" />,
          title: "gloabl.copuns",
          link: "/copuns",
          admin: true,
        },
      ],
    },
    {
      icon: <Users className="h-4 w-4" />,
      title: "dashbord.users",
      hasSubmenu: true,
      admin: true, // Main users section requires admin
      submenu: [
        {
          icon: <Users className="h-4 w-4" />,
          title: "dashbord.users",
          link: "/users",
          admin: true,
        },
        {
          icon: <History className="h-4 w-4" />,
          title: "dashbord.user_activity",
          link: "/users-activity",
          admin: true,
        },
      ],
    },
    // {
    //   icon: <Home className="h-4 w-4" />,
    //   title: "dashbord.home",
    //   link: `/`,
    // },
    {
      icon: <Building2 className="h-4 w-4" />,
      title: "dashbord.branches",
      link: `/branches`,
    },
  ];
};
